import api from './api';

export const getActiveAppOrigins = async () => {
  const response = await api.get('/api/private/app-origins');
  return response.data;
};

export const getAdminAppOrigins = async () => {
  const response = await api.get('/api/private/app-origins/admin', {
    params: { includeInactive: true },
  });
  return response.data;
};

export const createAppOrigin = async (payload) => {
  const response = await api.post('/api/private/app-origins', payload);
  return response.data;
};

export const updateAppOrigin = async (id, payload) => {
  const response = await api.put(`/api/private/app-origins/${id}`, payload);
  return response.data;
};

export const deleteAppOrigin = async (id) => {
  await api.delete(`/api/private/app-origins/${id}`);
};
